<template>
  <div style="height: 100%">
    <robot></robot>
  </div>
</template>

<script>
import robot from './components/robot.vue'
import ErrorStackParser from 'error-stack-parser'
import {
  getBaseErrorObj,
  getBrowserInfo,
  isMobileDevice,
} from '@/utils/index.js'
import { clientError } from '@/api/public'

export default {
  components: {
    robot,
  },
  methods: {
    handleResize() {
      const baseInfo = getBrowserInfo()
      if (isMobileDevice(baseInfo)) {
        // mobile环境处理逻辑
        this.$store.dispatch('user/changeIsMobile', true)
      } else {
        // PC环境处理逻辑
        this.$store.dispatch('user/changeIsMobile', false)
      }
    },
  },
  created() {
    this.handleResize()
    this.handleResizeDebounce = _.debounce(() => {
      this.handleResize()
    }, 100)
    window.addEventListener('resize', this.handleResizeDebounce) // 监听窗口大小变化
    window.onerror = function (message, url, lineNumber, columnNumber, error) {
      const parsedError = ErrorStackParser.parse(error)
      const baseObj = getBaseErrorObj()
      baseObj.error_msg = message
      baseObj.stackTrace = parsedError
      clientError(baseObj)
      return true // 阻止浏览器默认行为
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResizeDebounce) // 组件销毁前移除事件监听
  },
}
</script>

<style>
</style>
